import {
  EAssessmentStatus,
  EAssessmentType,
  IAcademicsAssessmentDetails,
} from 'src/apis/academics/academicsAssessments.interfaces';
import { mockUserAction } from '../users/userAction';
import { mockUserDetails } from '../users/userDetailsMock';
import { mockDocument } from '../documents/documentMock';

export const academicAssessmentDetailsMock: IAcademicsAssessmentDetails = {
  assessmentId: 'ASSESS-CLASS-1-EXAM-1',
  name: 'Class 1 - Mid Term Exam',
  description: 'Mid term examination for Class 1',
  assessmentType: EAssessmentType.MID_TERM,
  status: EAssessmentStatus.GRADED,
  classId: 1,
  courseId: 1,
  lessonPlanId: 1,
  maxScore: 100,
  totalStudents: 5,
  averageScore: 82.5,
  averagePercentage: 82.5,
  scheduledDate: '2024-03-15T09:00:00.000Z',
  conductedDate: '2024-03-15T10:30:00.000Z',
  dueDate: '2024-03-20T17:00:00.000Z',
  gradedDate: '2024-03-20T18:00:00.000Z',
  weightage: 30,
  instructions: 'Instructions for the assessment',
  remarks: 'Remarks for the assessment',
  actions: {
    created: mockUserAction,
  },
  subjects: [
    {
      courseId: 1,
      courseName: 'Science',
      subjectCode: 'SCI',
      subjectType: 'core',
      scheduledDuration: 90,
      scheduledDate: '2024-03-15T09:00:00.000Z',
      remarks: 'Science subject remarks - Overall good performance across all students',
      totalStudents: 5,
      averageScore: 80,
      averagePercentage: 80,
      scores: [
        {
          studentDetails: { ...mockUserDetails.basicDetails, firstName: 'Arjun', lastName: 'Sharma' },
          score: 85,
          isApplicableForGrading: true,
        },
        {
          studentDetails: { ...mockUserDetails.basicDetails, firstName: 'Priya', lastName: 'Patel' },
          score: 80,
          isApplicableForGrading: true,
        },
        {
          studentDetails: { ...mockUserDetails.basicDetails, firstName: 'Rohan', lastName: 'Kumar' },
          score: 75,
          isApplicableForGrading: true,
        },
        {
          studentDetails: { ...mockUserDetails.basicDetails, firstName: 'Ananya', lastName: 'Singh' },
          score: 70,
          isApplicableForGrading: true,
        },
        {
          studentDetails: { ...mockUserDetails.basicDetails, firstName: 'Vikram', lastName: 'Reddy' },
          score: 90,
          isApplicableForGrading: true,
        },
      ],
    },
    {
      courseId: 2,
      courseName: 'Mathematics',
      subjectCode: 'MATH',
      subjectType: 'core',
      scheduledDuration: 120,
      scheduledDate: '2024-03-16T09:00:00.000Z',
      remarks: 'Mathematics subject remarks - Strong performance with room for improvement in problem-solving',
      totalStudents: 5,
      averageScore: 78,
      averagePercentage: 78,
      scores: [
        {
          studentDetails: { ...mockUserDetails.basicDetails, firstName: 'Arjun', lastName: 'Sharma' },
          score: 80,
          isApplicableForGrading: true,
        },
        {
          studentDetails: { ...mockUserDetails.basicDetails, firstName: 'Priya', lastName: 'Patel' },
          score: 75,
          isApplicableForGrading: true,
        },
        {
          studentDetails: { ...mockUserDetails.basicDetails, firstName: 'Rohan', lastName: 'Kumar' },
          score: 70,
          isApplicableForGrading: true,
        },
        {
          studentDetails: { ...mockUserDetails.basicDetails, firstName: 'Ananya', lastName: 'Singh' },
          score: 65,
          isApplicableForGrading: true,
        },
        {
          studentDetails: { ...mockUserDetails.basicDetails, firstName: 'Vikram', lastName: 'Reddy' },
          score: 100,
          isApplicableForGrading: true,
        },
      ],
    },
    {
      courseId: 3,
      courseName: 'English',
      subjectCode: 'ENG',
      subjectType: 'core',
      scheduledDuration: 90,
      scheduledDate: '2024-03-17T09:00:00.000Z',
      remarks: 'English subject remarks - Excellent overall performance, students showed strong comprehension skills',
      totalStudents: 5,
      averageScore: 90,
      averagePercentage: 90,
      scores: [
        {
          studentDetails: { ...mockUserDetails.basicDetails, firstName: 'Arjun', lastName: 'Sharma' },
          score: 85,
          isApplicableForGrading: true,
        },
        {
          studentDetails: { ...mockUserDetails.basicDetails, firstName: 'Priya', lastName: 'Patel' },
          score: 90,
          isApplicableForGrading: true,
        },
        {
          studentDetails: { ...mockUserDetails.basicDetails, firstName: 'Rohan', lastName: 'Kumar' },
          score: 85,
          isApplicableForGrading: true,
        },
        {
          studentDetails: { ...mockUserDetails.basicDetails, firstName: 'Ananya', lastName: 'Singh' },
          score: 95,
          isApplicableForGrading: true,
        },
        {
          studentDetails: { ...mockUserDetails.basicDetails, firstName: 'Vikram', lastName: 'Reddy' },
          score: 95,
          isApplicableForGrading: true,
        },
      ],
    },
  ],
  reportCards: [
    {
      studentDetails: { ...mockUserDetails.basicDetails, firstName: 'Arjun', lastName: 'Sharma' },
      reportCard: {
        ...mockDocument,
        documentName: 'Report Card - Arjun Sharma',
      },
    },
    {
      studentDetails: { ...mockUserDetails.basicDetails, firstName: 'Priya', lastName: 'Patel' },
      reportCard: {
        ...mockDocument,
        documentName: 'Report Card - Priya Patel',
      },
    },
    {
      studentDetails: { ...mockUserDetails.basicDetails, firstName: 'Rohan', lastName: 'Kumar' },
      // No report card - will show generate button
    },
    {
      studentDetails: { ...mockUserDetails.basicDetails, firstName: 'Ananya', lastName: 'Singh' },
      reportCard: {
        ...mockDocument,
        documentName: 'Report Card - Ananya Singh',
      },
    },
    {
      studentDetails: { ...mockUserDetails.basicDetails, firstName: 'Vikram', lastName: 'Reddy' },
      // No report card - will show generate button
    },
  ],
};
